"use strict";

var _classCallCheck = require("/codebuild/output/src133026617/src/hopin-web/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/codebuild/output/src133026617/src/hopin-web/node_modules/@babel/runtime/helpers/createClass");

var _inherits = require("/codebuild/output/src133026617/src/hopin-web/node_modules/@babel/runtime/helpers/inherits");

var _possibleConstructorReturn = require("/codebuild/output/src133026617/src/hopin-web/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/codebuild/output/src133026617/src/hopin-web/node_modules/@babel/runtime/helpers/getPrototypeOf");

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

exports.__esModule = true;
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _reactDom = _interopRequireDefault(require("react-dom"));

var _jsxFileName = "/Users/tyler/Documents/GitHub/gatsby-plugins/transition-link/gatsby-plugin-transition-link/src/components/TransitionPortal.js";
var portalRoot = typeof document !== "undefined" ? document.body : false;

var PortalContainer = function PortalContainer(props) {
  var zIndex = function (level) {
    switch (level) {
      case 'bottom':
        return 1000;

      case 'top':
        return 1200;

      default:
        return 1100;
    }
  }(props.level);

  return /*#__PURE__*/_react.default.createElement("div", {
    className: "gatsby-plugin-transition-link-portal",
    style: {
      position: 'fixed',
      top: 0,
      left: 0,
      zIndex: zIndex
    },
    __self: void 0,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 19,
      columnNumber: 3
    }
  }, props.children);
};

var TransitionPortal = /*#__PURE__*/function (_react$Component) {
  _inherits(TransitionPortal, _react$Component);

  var _super = _createSuper(TransitionPortal);

  function TransitionPortal() {
    var _this;

    _classCallCheck(this, TransitionPortal);

    _this = _super.call(this);

    _this.componentDidMount = function () {
      portalRoot && portalRoot.appendChild(_this.el);
    };

    _this.componentWillUnmount = function () {
      portalRoot && portalRoot.removeChild(_this.el);
    };

    _this.el = typeof document !== "undefined" ? document.createElement('section') : false;
    return _this;
  }

  _createClass(TransitionPortal, [{
    key: "render",
    value: function render() {
      return this.el && portalRoot ? /*#__PURE__*/_reactDom.default.createPortal( /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, portalRoot && /*#__PURE__*/_react.default.createElement(PortalContainer, {
        styles: this.props.css,
        level: this.props.level,
        __self: this,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 54,
          columnNumber: 8
        }
      }, this.props.children)), this.el) : null;
    }
  }]);

  return TransitionPortal;
}(_react.Component);

exports.default = TransitionPortal;